import UserProfileForm from "./UserProfileForm";

export * from "./UserProfileForm";

export default UserProfileForm;